import React, { useState } from 'react';
import Select from 'react-select';
import { isEmpty, set, get } from 'lodash';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { MultiSelect } from 'react-multi-select-component';
import { SelectBoxStyles, checkIsNumber, checkCurrency, calculateTotValues, roundOff } from '../../../../../Components/helper';
import useShowHideSectionHooks from '../Hooks/useShowHideSectionHooks';
import useValidationHooks from '../Hooks/useValidationHooks';
import { useComponent } from '../../../../UserSetting/UsersLibrary/UserRights';
import { additionalFieldPath, errorpath } from '../../../ProductCosting/fieldPath';

export function AdditionalTable({ productInfoObj }) {
  const { productCostingstate, setProductCostingState, globalError, setGlobalErrors } = productInfoObj;
  const {
    additional: { additionalInfo, sumOfTotPrice },
    colourwayOptionsArr,
    productInfo: { currency },
    uomOptionsArr,
  } = productCostingstate;

  const {
    Users: { logInRights },
  } = useSelector((state) => state);
  const { CheckActionPermission } = useComponent();
  const { additional } = globalError;
  const { onChangeCheckIfErrorExist } = useValidationHooks();
  const { t } = useTranslation('common');

  const { statusState, controlAmberColour } = useShowHideSectionHooks(productInfoObj);

  const [error, setError] = useState([]);

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'products', 'costing', 'addEdit');

  const MasterDeleteAccess = CheckActionPermission(logInRights, 'products', 'costing', 'delete');

  const handleInputChange = async (value, path, supplierPath) => {
    const state = productCostingstate;
    set(state, path, value);
    await calculateTotPrice(state);
    if (error && error.length > 0) checkValidation();
  };

  const calculateTotPrice = async (copyState) => {
    const updatedArray = copyState?.additional?.additionalInfo.map((data) => {
      const { colourway } = data;
      const { quantityPerColSizLen } = data;
      if (!isEmpty(colourway) && !isEmpty(quantityPerColSizLen)) {
        const totalQuantity = quantityPerColSizLen * (colourway.length * 1);
        data.totalQuantity = totalQuantity;
      }
      if (!isEmpty(colourway) && !isEmpty(quantityPerColSizLen) && !isEmpty(data.pricePerUoM)) {
        const totalPrice = data.pricePerUoM * (quantityPerColSizLen * (colourway.length * 1));
        data.totalPrice = totalPrice;
      }
      return data;
    });
    const datas = await calculateTotValues(updatedArray, [{ key: 'totalPrice', updateKey: 'sumOfTotPrice' }]);
    set(copyState, additionalFieldPath().SUM_TOTAL_PRICE, datas.sumOfTotPrice);
    set(copyState, additionalFieldPath().SELECTED_TEMP_ADDTIONAL_DATA, updatedArray);
    setProductCostingState((state) => ({ ...state, ...copyState }));
  };
  const addNewRow = () => {
    setGlobalErrors({});

    if (!checkValidation()) {
      const copyState = productCostingstate;
      const obj = {
        colourway: [],
        quantityUom: null,
        totalQuantityUom: null,
        quantityPerColSizLen: '',
        pricePerUoM: '',
        title: '',
        totalQuantity: '',
      };
      copyState.additional.additionalInfo.push(obj);
      setProductCostingState((prevState) => ({ ...prevState, ...copyState }));
    }
  };

  const removeRow = async (index) => {
    const copyState = productCostingstate;
    if (Array.isArray(copyState?.additional?.additionalInfo) && copyState?.additional?.additionalInfo.length > 1) {
      copyState.additional.additionalInfo.splice(index, 1);
      calculateTotPrice(copyState);
    }
  };

  const checkValidation = () => {
    const required = ['colourway', 'quantityPerColSizLen', 'pricePerUoM', 'quantityUom', 'title'];
    const errors = [];
    let hasErrors = false;
    const data = productCostingstate.additional.additionalInfo;
    data.forEach((element, index) => {
      required.forEach((key) => {
        if (!element[key] || (typeof element[key] === 'object' && Object.keys(element[key]).length === 0)) {
          hasErrors = true;
          set(errors, `[${index}][${key}]`, 'This field is required');
        } else set(errors, `[${index}][${key}]`, '');
      });
    });
    setError(errors);
    return hasErrors;
  };

  const updateError = (path) => onChangeCheckIfErrorExist(path, globalError);

  const renderComponent = Array.isArray(additionalInfo) && additionalInfo.length > 0;
  return (
    <div className="table-responsive average-colourway-table">
      <table className="table common-custom-table product-costing-tbl common-class-bottom ">
        <thead>
          <tr>
            <th className="w-150px">{t('COSTING_TO_DO_LIST.COLORWAY')}</th>
            <th className="w-150px">{t('FILTER.ITEM')}</th>
            <th className="w-120px">{t('COSTING_TO_DO_LIST.QUANTITY')}</th>
            <th className="w-120px">{t('TAKING_DATES.UOM')}</th>
            <th className="w-100px">{t('FILTER.TOTAL_QUANTITY')}</th>
            <th className="w-120px">{t('FILTER.PRICE_PER_UNITS')}</th>
            <th className="w-120px">{t('FILTER.TOTAL_PRICE')}</th>
            {!statusState && <th className="w-70px">{t('COSTING_TO_DO_LIST.ACTION')}</th>}
          </tr>
        </thead>
        <tbody>
          {renderComponent &&
            additionalInfo.map((data, index) => {
              return (
                <tr key={data?._id}>
                  <td className={(data.isChangedBySupplierColourway || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data' : ''}>
                    {!statusState ? (
                      <>
                        <MultiSelect
                          name="colorway"
                          onChange={(selected) => {
                            handleInputChange(selected, additionalFieldPath(index).SELECTED_COLOURWAY, [
                              additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TOTAL_QUANTITY,

                              additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE,
                              additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_COLOURWAY,
                            ]);
                            if (get(additional, `[${index}].colourway`, '')) {
                              updateError(errorpath(index).ADDITIONAL.ERROR_COLOURWAY);
                            }
                          }}
                          options={colourwayOptionsArr}
                          className="custom-multiselect"
                          value={
                            data?.colourway
                              ? data?.colourway?.map((ele) => {
                                  return {
                                    ...ele,
                                    label: ele?.name,
                                    value: ele?.name,
                                  };
                                })
                              : []
                          }
                        />
                        <span className="error-message">{get(error, `[${index}].colourway`, '') || get(additional, `[${index}].colourway`, '')}</span>
                      </>
                    ) : (
                      data?.colourway?.map((val) => val.name).join(', ')
                    )}
                  </td>
                  <td className={(data.isChangedBySupplierTitle || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data ' : ''}>
                    {!statusState ? (
                      <>
                        <div className="d-flex align-items-center">
                          <div className="flex-fill">
                            <input
                              className="form-control text-bordered"
                              value={data.title}
                              onChange={(e) => {
                                handleInputChange(e.target.value, additionalFieldPath(index).ITEM, [additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TITLE]);
                                if (get(additional, `[${index}].title`, '')) {
                                  updateError(errorpath(index).ADDITIONAL.ERROR_TITLE);
                                }
                              }}
                            />
                          </div>{' '}
                        </div>
                        <span className="error-message">{get(error, `[${index}].title`, '') || get(additional, `[${index}].title`, '')}</span>
                      </>
                    ) : (
                      data.title
                    )}
                  </td>
                  <td
                    className={(data.isChangedBySupplierTotalQuantityPerSizColLen || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data' : ''}
                  >
                    {!statusState ? (
                      <>
                        <div className="d-flex align-items-center">
                          <div className="flex-fill">
                            <input
                              onChange={(e) => {
                                if (checkIsNumber(e.target.value)) {
                                  handleInputChange(e.target.value, additionalFieldPath(index).QUANTITY_PER_UNIT, [
                                    additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_QUANTITY_PER_SIZE_COl,
                                    additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TOTAL_QUANTITY,
                                    additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE,
                                  ]);
                                  if (get(additional, `[${index}].quantityPerColSizLen`, '')) {
                                    updateError(errorpath(index).ADDITIONAL.ERROR_QUANTITY);
                                  }
                                }
                              }}
                              value={data.quantityPerColSizLen}
                              type="text"
                              className="form-control text-bordered text-left"
                            />
                          </div>{' '}
                        </div>
                        <span className="error-message">
                          {get(error, `[${index}].quantityPerColSizLen`, '') || get(additional, `[${index}].quantityPerColSizLen`, '')}
                        </span>
                      </>
                    ) : (
                      data.quantityPerColSizLen
                    )}
                  </td>
                  <td className={(data.isChangedBySupplierQuantityUom || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data' : ''}>
                    {!statusState ? (
                      <>
                        <Select
                          options={uomOptionsArr}
                          onChange={(selected) => {
                            handleInputChange(selected, additionalFieldPath(index).UOM_ONE_SELECTED, [
                              additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_QUANTITY_UOM,
                            ]);
                            if (get(additional, `[${index}].quantityUom`, '')) {
                              updateError(errorpath(index).ADDITIONAL.ERROR_QUANTITY_UOM);
                            }
                          }}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.name}
                          value={data.quantityUom}
                          styles={SelectBoxStyles}
                          menuPosition="fixed"
                          menuShouldBlockScroll
                          menuShouldScrollIntoView
                        />
                        <span className="error-message">{get(error, `[${index}].quantityUom`, '') || get(additional, `[${index}].quantityUom`, '')}</span>
                      </>
                    ) : (
                      data?.quantityUom?.name
                    )}
                  </td>
                  <td
                    className={
                      (data.isChangedBySupplierTotalQuantity || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data text-left' : 'text-left'
                    }
                  >
                    {data.totalQuantity} {data?.quantityUom?.name || ''}
                  </td>

                  <td
                    className={
                      (data.isChangedBySupplierPricePerUnit || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data text-left' : 'text-left'
                    }
                  >
                    {!statusState ? (
                      <>
                        <input
                          onChange={(e) => {
                            if (checkIsNumber(e.target.value)) {
                              handleInputChange(e.target.value, additionalFieldPath(index).PRICE_PER_UNIT, [
                                additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE,
                                additionalFieldPath(index).IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT,
                              ]);
                            }
                            if (get(additional, `[${index}].pricePerUoM`, '')) {
                              updateError(errorpath(index).ADDITIONAL.ERROR_PRICEPER_UNIT);
                            }
                          }}
                          value={data.pricePerUoM}
                          type="text"
                          className="form-control text-bordered text-left"
                        />
                        <span className="error-message">{get(error, `[${index}].pricePerUoM`, '') || get(additional, `[${index}].pricePerUoM`, '')}</span>
                      </>
                    ) : (
                      data.pricePerUoM
                    )}
                  </td>
                  <td
                    className={
                      (data.isChangedBySupplierTotalPrice || data.isNewEntryBySupplier) && controlAmberColour ? 'suggested-data text-left' : 'text-left'
                    }
                  >
                    {checkCurrency(currency, data?.totalPrice)} {roundOff(data?.totalPrice, 4, true)}
                  </td>
                  {!statusState && (
                    <td>
                      <div className="d-flex align-items-center">
                        {MasterAddEditAccess && (
                          <button
                            className="btn btn-outline"
                            title={t('DEVLOPMENT_ORDER.PRODUCT_INFORMATION.MULTI_PRODUCT_COSTING.TABLES.ADDITIONAL_TABLES.ADD')}
                            onClick={addNewRow}
                            type="button"
                            aria-label="add"
                          >
                            <span className="icon-Add f-24" />
                          </button>
                        )}
                        {MasterDeleteAccess && (
                          <button
                            className="btn btn-outline"
                            title={t('SPEC_TEMP_LIBRARY.DELETE')}
                            onClick={() => removeRow(index)}
                            disabled={additionalInfo && additionalInfo.length === 1}
                            type="button"
                            aria-label="delete"
                          >
                            <span className="icon-Delete f-24" />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          <tr>
            <td colSpan="6" />
            <td colSpan={2} className="text-left">
              {checkCurrency(currency, sumOfTotPrice)} {roundOff(sumOfTotPrice, 4, true)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default AdditionalTable;
